import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'
import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths'
import addDays from 'date-fns/addDays'
import isFirstDayOfMonth from 'date-fns/isFirstDayOfMonth'
import isLastDayOfMonth from 'date-fns/isLastDayOfMonth'

export default function useDataTransform(props, data) {
  let tx = useDataValue({
    viewPath: props.viewPath,
    context: 'treatment_card',
    path: 'txs',
  })

  return useMemo(() => {
    let start_date = tx.start_date || tx.estimated_start_date
    let end_date = tx.end_date || tx.estimated_end_date

    let length_in_months = 0
    if (end_date) {
      let start = new Date(start_date)
      let end = new Date(end_date)

      // Adjust end_date for length-based calculations
      // (start is 1st of month AND end is last day of month)
      if (isFirstDayOfMonth(start) && isLastDayOfMonth(end)) {
        end = addDays(end, 1)
      }

      length_in_months = differenceInCalendarMonths(end, start)
    }

    return {
      ...data,
      start_date,
      length_in_months,
    }
  }, [data, tx])
}
